var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgAnyone(props) {
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.18 19.15"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id,
    transform: "translate(-.04 -1.57)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.52,
    cy: 11.09,
    r: 8.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id2,
    transform: "translate(-.04 -1.57)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 8.75,
    r: 8.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id3,
    transform: "translate(-.04 -1.57)"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.28,
    cy: 8.75,
    r: 8.75,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 488",
    clipPath: `url(#${_id})`
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 241",
    d: "M8.76 19.14a5.2 5.2 0 01.84-2.18 2 2 0 01.81-.51c.94-.37 1.91-.67 2.85-1.06a15 15 0 001.62-.89c.08 0 .19-.12.2-.19a5.44 5.44 0 000-1.93 5.29 5.29 0 01-.53-1.79l-.11.06a2.7 2.7 0 01-.42-.62 5.94 5.94 0 01-.27-1.18c0-.31-.11-.67.34-.76a7.77 7.77 0 010-3.36 2.39 2.39 0 011.21-1.64 9.36 9.36 0 011.49-.66 1.68 1.68 0 01.67 0 9 9 0 011.27.15c.42.08.85.19 1 .67h.63c.07.12.1.26.18.3a1.33 1.33 0 01.7 1.11 11.31 11.31 0 01-.17 3.53.54.54 0 01.37.67.52.52 0 01-.06.13c-.23.56 0 1.34-.78 1.78a4.55 4.55 0 01-.59 1.66 3.15 3.15 0 000 1.67c0 .24.36.49.62.64a10.76 10.76 0 001.45.7c1 .4 2 .73 3 1.16a1.53 1.53 0 01.71.71 18.88 18.88 0 01.68 1.82z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 490",
    clipPath: `url(#${_id2})`
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 242",
    d: "M-.04 16.81a5.29 5.29 0 01.84-2.19 2 2 0 01.81-.51c.94-.36 1.91-.67 2.84-1.06a15.09 15.09 0 001.63-.88c.08-.05.19-.13.2-.19a5.69 5.69 0 000-1.93 4.93 4.93 0 01-.53-1.79l-.11.06a2.82 2.82 0 01-.42-.62 6.75 6.75 0 01-.26-1.18c0-.31-.1-.67.35-.76a7.62 7.62 0 01-.03-3.33A2.41 2.41 0 016.48.79 10.18 10.18 0 018.02.08a1.56 1.56 0 01.68 0 10.75 10.75 0 011.26.1c.41.08.84.19 1 .67h.62c.08.13.1.27.19.3a1.34 1.34 0 01.7 1.12 11.61 11.61 0 01-.17 3.53.53.53 0 01.36.63.69.69 0 010 .13c-.23.56 0 1.34-.79 1.78a4.53 4.53 0 01-.57 1.79 3.12 3.12 0 000 1.66c0 .25.36.5.61.65a11.37 11.37 0 001.45.7c1 .4 2 .73 3 1.16a1.6 1.6 0 01.72.71 16.5 16.5 0 01.67 1.82z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 492-4",
    clipPath: `url(#${_id3})`
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 243-4",
    d: "M17.52 16.81a5.17 5.17 0 01.85-2.19 2 2 0 01.81-.51c.94-.36 1.91-.67 2.84-1.06a14.07 14.07 0 001.62-.88c.08-.05.19-.13.2-.19a5.44 5.44 0 000-1.93 5.36 5.36 0 01-.53-1.79l-.11.06a3.75 3.75 0 01-.42-.62 5.94 5.94 0 01-.27-1.18c-.05-.31-.11-.67.34-.76a7.77 7.77 0 010-3.36A2.42 2.42 0 0124.06.76 9.75 9.75 0 0125.6.05a1.56 1.56 0 01.68 0 11 11 0 011.27.16c.41.08.84.19 1 .67h.63c.07.13.1.27.18.3a1.32 1.32 0 01.6 1.04 11.31 11.31 0 01-.17 3.53.54.54 0 01.37.67.38.38 0 01-.06.13c-.23.56 0 1.34-.78 1.78a4.39 4.39 0 01-.58 1.79 3 3 0 000 1.66c0 .25.36.5.61.65a10.76 10.76 0 001.45.7c1 .4 2 .73 3 1.16a1.6 1.6 0 01.72.71 18.82 18.82 0 01.67 1.82z"
  }))));
}
export default SvgAnyone;